module.exports = __webpack_public_path__ + "7f04718d913850b4935ea08c14e3b6cc.pdf";